import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ValidationSummary } from '../../shared/misc-classes';

@Component({
  selector: 'browser-fail-dialog',
  templateUrl: 'browser-fail-dialog.html',
  styleUrls: []
})
export class BrowserFailDialog {

  constructor(
    public dialogRef: MatDialogRef<BrowserFailDialog>) {
     }

  onNoClick(): void {
    this.dialogRef.close();
  }

}